import request from "@/router/axios"
export const any = () => {
    return request({
        url: `/api/sys/tenant/any`,
        method: 'get',
    })
}